import { FunctionComponent, PropsWithChildren } from 'react';
import { FormattedMessage } from 'react-intl';

type HighlightedFormContainerProps = PropsWithChildren<{
    instructionMessageId: string;
}>;

export const HighlightedFormContainer: FunctionComponent<HighlightedFormContainerProps> = ({
    instructionMessageId,
    children,
}) => {
    return (
        <div className="margin-20 padding-20 bg-highlight-lightest border border-color-primary rounded">
            <div className="text-color-primary text-medium text-size-14">
                <FormattedMessage id={instructionMessageId} />
            </div>
            {children}
        </div>
    );
};
